import React from 'react';
//import "./GameViews/gameViews.css";
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import InvestmentBuyInfoCard from './investment_buy_info_card';
import InvestmentSellInfoCard from './investment_sell_info_card';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import reformatDateToDisplay from '../../../objects/CommonUse/reformatDateToDisplay_function';
import setInvestmentText from './objects/set_investment_text';
import WaitTimeSpinner from '../../shared-components/wait_time_spinner';

class InvestmentBuySellModal extends React.Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {
            purchaseMade: false,
            saleMade: false,
            nextProcess: false,
            waitState: false,
            timeout: "",
         
        }  
        this.sellArr = [];
        this.priceArr = [];
        this.investType = "";
    }

initializeValues(){
    this.displayType = this.props.tranType;
    if (this.investType !== this.props.investType){
        this.investType = this.props.investType;
    }
    this.checkIfAlreadyOwned(this.props.investType);
    this.setTextByInvestType(this.props.investType);
    this.determineButtonText();
    this.addBondDividendInfoToSummaryArr();
    this.sortInvestMasterByName();
}

checkIfAlreadyOwned(){
    this.investTypeFound = false;
    if (this.props.summaryTranArr.length === 0){
        // if no trans are found for this type, then default to the 'buy' screen option
        this.displayType = "buy";
    }
}

setTextByInvestType(investType){
    const investmentTextObj = setInvestmentText(investType);
    const headingText = investmentTextObj.headingText;
    const investTypeText = investmentTextObj.investTypeText;
    const pluralText = investTypeText + "s";
    let toggleText = "";
    switch (this.displayType){
        case "buy":
            this.titleLit = "Review/Select the " + headingText + " You Wish To Purchase";
            this.generalLit = "This process allows you to review and buy " + investTypeText  + "s. If you wish to purchase " +
                    pluralText + ", enter a quantity of units that you want to buy in the 'Purchase Quantity'   " +
                    "field.  You can click the right-arrow to display more detailed information about the " +
                    investType + ".";
            this.confirmButtonText = "Review/Confirm Purchases";
            toggleText = " sell ";
            break;
        case "info":
        case "sell":
             this.titleLit = "List of " + pluralText + " That You Currently Own";
                this.generalLit = "A list of all of the " + investTypeText + "s that you own is displayed below. " +
                    "You can click the right-arrow to display the detail purchase transactions. " +
                    "This page displays the current status of the " + pluralText + " that you own. You can " +
                    "go to the 'Display Your Portfolio' page to see how your " + investTypeText + "s have done " +
                    "for the past year."
                this.confirmButtonText = "Review/Confirm Sales";
                toggleText = " buy ";
                break;
        default:
            break;
    }
    this.buttonLit = "Click the button below to switch from being able to " + this.displayType + " " +
        pluralText + " to being able to " + toggleText + pluralText;
}

determineButtonText(){
    this.buttonText = "";
    let investType = setInvestmentText(this.props.investmentMasterArr[0].investmentType).headingText;
    investType += "s";
    this.displayToggleButton = true;
    switch (this.displayType){
        case "buy":
            if (this.props.summaryTranArr.length > 0){
                this.buttonText = "sell-" + investType;
            }else{
                this.displayToggleButton = false;
            }
            break;
        case "sell":
            this.buttonText = "buy-" + investType;
            break;
        default:
            break;
    }
   
}

addBondDividendInfoToSummaryArr(){
    this.summaryTranArr = JSON.parse(JSON.stringify(this.props.summaryTranArr));
    this.summaryTranArr.sort((a, b) => 
        (a.investmentName + +a.transNbr > b.investmentName + +b.transNbr) ? 1 : -1)
    for (let i=0; i<this.props.summaryTranArr.length; i++){
        const shortName = this.props.summaryTranArr[i].investShortName;
        const masterInfo = this.props.investmentMasterArr.find(elem => elem.investShortName === shortName);
        if (masterInfo && masterInfo.investmentType === "bond"){
            this.summaryTranArr[i] = {...this.summaryTranArr[i], bondInfo: masterInfo.bondInfo, 
                classification: masterInfo.classification, investmentType: masterInfo.investmentType,
                investClass: masterInfo.investClass};
        }else{
            if (masterInfo.dividendInfo){
                this.summaryTranArr[i] = {...this.summaryTranArr[i], dividendInfo: masterInfo.dividendInfo,
                    investmentType: masterInfo.investmentType, investClass: masterInfo.investClass}
            }
        }
    }
}

sortInvestMasterByName(){
    this.sortedInvestmentMaster = JSON.parse(JSON.stringify(this.props.investmentMasterArr));
    this.sortedInvestmentMaster.sort((a, b) => (a.investmentName  > b.investmentName ) ? 1 : -1)
    this.determineQuantity();
}

determineQuantity(){
    this.investmentMasterArr = [];
    for (let i=0; i<this.props.investmentMasterArr.length; i++){
        const shortName = this.props.investmentMasterArr[i].investShortName;
        const summaryTranArr = this.summaryTranArr.filter(item => item.investShortName === shortName);
        let quantity = 0;
        for (let i=0; i<summaryTranArr.length; i++){
            quantity += summaryTranArr[i].quantity;
        }
        this.investmentMasterArr.push({...this.props.investmentMasterArr[i], quantity: quantity});
    }
}

goToNextProcess(buttonText){
    this.displayType = buttonText.split("-")[0];
    this.props.setBuyOrSell(this.displayType);
    this.setTextByInvestType(this.props.investType);
    this.determineButtonText();
    this.setState({nextProcess: true});
}


render() {
        this.initializeValues();
        if (this.displayType === "sell"){
             this.stockGeneralInfo =  this.summaryTranArr.map((tranSummary, index) =>
                <InvestmentSellInfoCard key={index} investInfo={tranSummary} 
                    investType={this.props.investType}
                    displayType={this.displayType}
                    buyTransArr={this.props.buyTranArr}
                    onSellInvestment={(investmentObj) => this.props.saveTransaction(investmentObj)}
                    moneyBuildInfo = {() => this.props.moneyBuildInfo()}
                    processError = {(errorObj) => this.props.processError(errorObj)} />
                );
        }
        if (this.displayType === "buy" ){
            this.stockGeneralInfo = this.investmentMasterArr.map((investment, index) =>
                <InvestmentBuyInfoCard key={index} investInfo={investment} 
                    investType={this.props.investType}
                    onPurchaseInvestment={(investmentObj) => this.props.saveTransaction(investmentObj)}
                    currentGameMonth={this.props.currentGameMonth}
                    moneyBuildInfo = {() => this.props.moneyBuildInfo()}
                    saveMaturityDate={(maturityDateObj) => this.props.saveMaturityDate(maturityDateObj)}
                    processError = {(errorObj) => this.props.processError(errorObj)}/>
                );
        }
        
        this.className = "col-sm-8 mx-0 mt-1";
        const scrollable = true; 
return <>
        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" 
            dialogClassName={this.gutters} animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title className="text-center">{this.titleLit}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.displayToggleButton ? 
                <>
                <div className="text-left mx-4">
                    {this.buttonLit}
                </div>
                <div className="text-center">
                    <button className="good-looking-button-gameView btn-primary"
                        onClick={() => this.goToNextProcess(this.buttonText)}>
                            {this.buttonText}
                    </button>
                </div>
                </>
            :
                null
            }
                        
            <div className="row mt-1 mx-4">
                <div className="col-sm-6">
                    <span className="font-weight-bold">Current Cash:</span>
                    <span className="ml-4">
                        {doubleToStringMonthly(this.moneyBuildInfo.gameData.currentCash)}</span>
                </div>
                    <div className="col-sm-6">
                    <span className="font-weight-bold">Game Date:</span>
                    <span className="ml-4">
                        {reformatDateToDisplay(this.moneyBuildInfo.gameData.currentGameDate)}</span>
                </div>
            </div>
        
            <div className={`modal-body ${scrollable ? 'scrollable' : ''}`}>
                <div className="overflow-scroll">
                    <div className="mt-1">
                        {this.generalLit}
                    </div>
       
                    <div className="mt-2  overflow-scroll">
                        {this.state.waitState   ?
                            <WaitTimeSpinner/>
                        :
                            <span>
                                <div className="mt-2  mx-4">
                                    {this.stockGeneralInfo}
                                </div>
                            </span>
                        }
                    </div>
                </div>
            </div>
          
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
            <div className={this.errorClass}>
                {this.errorMsg}
            </div>
            {this.props.transactionArr.length > 0 ?
                <div>
                    <Button variant="secondary"  
                        onClick={() => this.props.openConfirmModal(this.displayType)}>
                            {this.confirmButtonText}
                    </Button>
                </div>
            :
                null
            }   
          
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                      Close
            </Button>
        </Modal.Footer>
        </Modal>
    </>
  }

componentDidMount(){
    this._isMounted = true;
}


}

export default InvestmentBuySellModal;